// Exact codes enforced by the m2_static_data_shock_type_check CHECK constraint
// on public.m2_static_data.shock_type (db/schema.sql). Keep in sync with that
// constraint if it changes.
export const SHOCK_TYPE_CODES = [
  "ACTIF_NON_COTE",
  "ACTIF_NON_ECHANGEABLE_SUR_UN_MARCHE_REGLEMENTE_OU_UN_MTF",
  "ACTION_TYPE_1",
  "ACTION_TYPE_1_LONG_TERME",
  "ACTION_TYPE_1_PARTICIPATION",
  "ACTION_TYPE_2",
  "ACTION_TYPE_2_LONG_TERME",
  "ACTION_TYPE_2_PARTICIPATION",
  "ACTIONS",
  "AUTRES_DEPOTS_AVEC_UN_TERME_SUPERIEUR_UN_AN",
  "AUTRES_DEPOTS_DE_COURT_TERME_(MOINS_UN_AN)",
  "AUTRES_INVESTISSEMENTS",
  "AUTRES_PRETS_AVEC_GARANTIE",
  "AVANCES_SUR_POLICES",
  "BIEN_IMMOBILIER_(EN_CONSTRUCTION_POUR_USAGE_PROPRE)",
  "BIENS_EQUIPEMENTS_(USAGE_PROPRE)",
  "BILLETS_DE_TRESORERIE",
  "BONS_DU_TRESOR",
  "CONTRAT_ECHANGE_(SWAP)_DE_CHANGE",
  "CONTRAT_ECHANGE_(SWAP)_DE_RISQUE_DE_CATASTROPHE_ET_CLIMATIQUE",
  "CONTRAT_ECHANGE_(SWAP)_DE_RISQUE_DE_MORTALITE",
  "CONTRAT_ECHANGE_(SWAP)_DE_TAUX",
  "CONTRAT_ECHANGE_(SWAP)_DE_TAUX_ET_DE_CHANGE",
  "CONTRAT_ECHANGE_(SWAP)_DE_TITRES",
  "CONTRAT_RISQUE_DE_MORTALITE",
  "CONTRAT_SUR_RISQUE_DE_CATASTROPHE_ET_CLIMATIQUE",
  "CONTRAT_TERME_DE_CHANGE",
  "CONTRAT_TERME_DE_MATIERES_PREMIERES",
  "CONTRAT_TERME_DE_TAUX",
  "CONTRAT_TERME_SUR_ACTIONS_ET_INDICES_ACTION",
  "CONTRATS_ECHANGE_(SWAPS)_AUTRES",
  "CONTRATS_TERME_(FORWARDS)_AUTRES",
  "CONTRATS_TERME_(FORWARDS)_DE_CHANGE",
  "CONTRATS_TERME_(FORWARDS)_DE_TAUX",
  "CONTRATS_TERME_(FORWARDS)_SUR_RISQUE_DE_CATASTROPHE_ET_CLIMATIQUE",
  "CONTRATS_TERME_(FORWARDS)_SUR_RISQUE_DE_MORTALITE",
  "CONTRATS_TERME_(FUTURES)_AUTRES",
  "DEPOT_SFG",
  "DEPOTS",
  "DEPOTS_CEDANTES",
  "DEPOTS_CEDANTES_MOINS_1_AN",
  "DEPOTS_CEDANTES_PLUS_1_AN",
  "DEPOTS_MOINS_1_AN",
  "DEPOTS_PLUS_1_AN",
  "DEPOTS_TRANSFERABLES_(EQUIVALENT_DE_LA_TRESORERIE)",
  "DERIVE_DE_CREDIT_SUR_TRANSFERT_DE_RENDEMENT_(TOTAL_RETURN_SWAP)",
  "DERIVES_DE_CREDIT_AUTRES",
  "DERIVES_SUR_EVENEMENT_DE_CREDIT_(CREDIT_DEFAULT_SWAP)",
  "ECHANGE_DE_SPREAD_DE_CREDIT_(CREDIT_SPREAD_SWAP)",
  "FONDS_ACTION",
  "FONDS_ALLOCATION_ACTIFS",
  "FONDS_ALTERNATIFS",
  "FONDS_DE_CAPITAL_INVESTISSEMENT",
  "FONDS_IMMOBILIERS",
  "FONDS_INFRASTRUCTURE",
  "FONDS_INVESTISSEMENT_AUTRES",
  "FONDS_MONETAIRES",
  "FONDS_OBLIG_ETAT",
  "FONDS_OBLIG_ETAT_COVERED",
  "FONDS_OBLIG_ETAT_GUARANTED",
  "FONDS_OBLIG_SOCIETES",
  "FONDS_OBLIG_SOCIETES_COVERED",
  "FONDS_OBLIG_SOCIETES_GUARANTED",
  "FONDS_OBLIGATAIRES",
  "IMMOBILIER_(DE_BUREAU_ET_COMMERCIAL)",
  "IMMOBILIER_(RESIDENTIEL)",
  "IMMOBILIER_(USAGE_PROPRE)",
  "IMMOBILIER_EN_CONSTRUCTION",
  "IMMOBILISATIONS_CORPORELLES_AUTRES",
  "OBLIG_COVERED",
  "OBLIG_GUARANTED",
  "OBLIGATIONS_CONVERTIBLES",
  "OBLIGATIONS_DES_BANQUES_CENTRALES_NATIONALES",
  "OBLIGATIONS_DES_COLLECTIVITES_MUNICIPALES",
  "OBLIGATIONS_DES_COLLECTIVITES_REGIONALES",
  "OBLIGATIONS_ENTREPRISES_AUTRES",
  "OBLIGATIONS_ETAT",
  "OBLIGATIONS_GOUVERNEMENTALES_LIBELLES_DANS_UNE_DEVISE_ETRANGERE",
  "OBLIGATIONS_ORDINAIRES",
  "OBLIGATIONS_ORGANISATIONS_SUPRA-NATIONALES",
  "OBLIGATIONS_SECURISEES",
  "OBLIGATIONS_SECURISEES_ORDINAIRES",
  "OBLIGATIONS_SECURISEES_SOUMISES_UNE_LEGISLATION_PARTICULIERE",
  "OBLIGATIONS_SOUVERAINES_AUTRES",
  "OPTION_SUR_SPREAD_DE_CREDIT_(CREDIT_SPREAD_OPTION)",
  "OPTIONS_ACHAT_(CALL)_ACTIONS_OU_SUR_INDICES_ACTION",
  "OPTIONS_ACHAT_(CALL)_AUTRES",
  "OPTIONS_ACHAT_(CALL)_DE_CHANGE",
  "OPTIONS_ACHAT_(CALL)_DE_MATIERES_PREMIERES",
  "OPTIONS_ACHAT_(CALL)_SUR_OBLIGATION",
  "OPTIONS_ACHAT_(CALL)_SUR_RISQUE_DE_MORTALITE",
  "OPTIONS_ACHAT_(CALL)_SUR_RISQUES_DE_CATASTROPHE_ET_CLIMATIQUE",
  "OPTIONS_DE_VENTE_(PUT)_ACTIONS_OU_SUR_INDICES_ACTION",
  "OPTIONS_DE_VENTE_(PUT)_AUTRES",
  "OPTIONS_DE_VENTE_(PUT)_DE_CHANGE",
  "OPTIONS_DE_VENTE_(PUT)_DE_MATIERES_PREMIERES",
  "OPTIONS_DE_VENTE_(PUT)_SUR_OBLIGATIONS",
  "OPTIONS_DE_VENTE_(PUT)_SUR_RISQUE_DE_MORTALITE",
  "OPTIONS_DE_VENTE_(PUT)_SUR_RISQUES_DE_CATASTROPHE_ET_CLIMATIQUE",
  "PRETS_A_D_AUTRES_PERSONNES_PHYSIQUES",
  "PRETS_AUX_MEMBRES_DE_L_AMSB",
  "PRETS_ET_PRETS_HYPOTHECAIRES_AUTRES",
  "PRETS_GAGES_SUR_DES_TITRES",
  "PRETS_HYPOTHECAIRES",
  "PRETS_SANS_GARANTIES",
  "RECLASS_CREANCES",
  "SWAP_DE_RENDEMENT_TOTAL",
  "SWAPTIONS_OPTIONS_ACHAT_(CALL)",
  "SWAPTIONS_OPTIONS_DE_VENTE_(PUT)",
  "TITRES_GARANTIS_AUTRES",
  "TITRES_GARANTIS_RISQUE_ACTION",
  "TITRES_GARANTIS_RISQUE_DE_CATASTROPHE_ET_CLIMATIQUE",
  "TITRES_GARANTIS_RISQUE_DE_CHANGE",
  "TITRES_GARANTIS_RISQUE_DE_CREDIT",
  "TITRES_GARANTIS_RISQUE_DE_MORTALITE",
  "TITRES_GARANTIS_RISQUE_DE_TAUX",
  "TITRES_GARANTIS_RISQUE_IMMOBILIER",
  "TITRES_GARANTIS_RISQUE_LIES_AUX_MATIERES_PREMIERES",
  "TITRES_HYBRIDES",
  "TITRES_MONETAIRES",
  "TITRES_STRUCTURES_AUTRES",
  "TITRES_STRUCTURES_RISQUE_ACTION",
  "TITRES_STRUCTURES_RISQUE_DE_CATASTROPHE_ET_CLIMATIQUE",
  "TITRES_STRUCTURES_RISQUE_DE_CHANGE",
  "TITRES_STRUCTURES_RISQUE_DE_CREDIT",
  "TITRES_STRUCTURES_RISQUE_DE_MORTALITE",
  "TITRES_STRUCTURES_RISQUE_DE_TAUX",
  "TITRES_STRUCTURES_RISQUE_IMMOBILIER",
  "TITRES_STRUCTURES_RISQUE_LIES_AUX_MATIERES_PREMIERES",
  "TITRES_SUBORDONNES",
  "TRESORERIE",
  "WARRANTS",
  "WARRANTS_OPTIONS_DE_VENTE_(PUT)",
] as const;

export const SHOCK_TYPE_OPTIONS = SHOCK_TYPE_CODES.map((code) => ({
  value: code,
  label: code,
}));
